import React, { useCallback, useEffect, useState, createContext } from "react";
import { getUserAccountInfo } from './utils';
import { useContext } from "react";

//Create the Context
const DownloadUserContext = createContext();

//Create a provider Component
export const DownloadUserProvider = ({children}) => {
    const [ userAccountInfo, setUserAccountInfo ] = useState(null);
    const [ reload, setReload] = useState(true);

    const loadUserAccountInfo = useCallback(() => {
        getUserAccountInfo(setUserAccountInfo)
    })
    useEffect(() => {
        loadUserAccountInfo();
        setReload(false);
    },[reload])
    return (
        <DownloadUserContext.Provider
        value = {{
            userAccountInfo,
            setUserAccountInfo,
            setReload
        }}
        >
            {children}
        </DownloadUserContext.Provider>
    )
}

// Custom hook to use the DownloadUserContext
export const useDownloadUser = () => {
    const context = useContext(DownloadUserContext);
    if(!context){
        throw new Error(
            "useDownloadUser must be used within DownloadUserProvider"
        )
    }
    return context;
}